import Vue from 'vue';

// Loading state handler
export const LoadingState = new Vue();
